"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createFields = _interopRequireDefault(require("./createFields"));

var _plain = _interopRequireDefault(require("./structure/plain"));

var _default = (0, _createFields["default"])(_plain["default"]);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/Fields.js
// module id = 1754
// module chunks = 0